import instance from "./index";
import ExceptionHandling from "./ExceptionHandling";

export default class CartService {

    issueToken(items, customerData, cartData) {
        return instance()({
            method: "post",
            url: "/api/issue_token",
            data: {
                items:            items,
                customer_id:      customerData.customerID,
                customer_name:    customerData.customerName,
                customer_tel:     customerData.customerTel,
                invoice_discount: cartData.invoiceDiscount,
                disc_type:        cartData.discType,
                description:      cartData.description,
                doctor_details:   cartData.doctorDetails,
                patient_details:  cartData.patientDetails,
            },
        })
        .then(res => res.data)
        .catch(e => ExceptionHandling.HandleErrors(e));
    }

    loadByToken(tokenNumber) {
        return instance()({
            method: "post",
            url: "/api/load_token",
            data: { token_number: tokenNumber },
        })
        .then(res => res.data)
        .catch(e => {
            if(e.response?.data){
                return e.response.data;
            }

            return { alert: 'error', msg: 'Token not found. Please check the token number.'}
        });
    }

   tokenList(keyword = '', statusType = '0', date = '') {
        return instance()({
            method: "post",         
            url: "/api/token_list",
            data: { keyword, statusType, date}, 
        })
        .then(res => res.data)
        .catch(e => ExceptionHandling.HandleErrors(e));
    }

    canceledCart(cartId) {
        return instance()({
            method: "post",
            url: "/api/cancel",
            data: { cart_id: cartId },
        })
        .then(res => res.data)
        .catch(e => ExceptionHandling.HandleErrors(e));
    }

    completeCart(cartId) {
        return instance()({
            method: "post",
            url: "/api/complete",
            data: { cart_id: cartId },
        })
        .then(res => res.data)
        .catch(e => ExceptionHandling.HandleErrors(e));
    }

    reprintSlip(cartId) {
        return instance()({
            method: "post",
            url: "/api/reprint_slip",
            data: { cart_id: cartId },
        })
        .then(res => res.data)
        .catch(e => ExceptionHandling.HandleErrors(e));
    }

    revertToTokenised(cartId) {
        return instance()({
            method: "post",
            url: "/api/revert_token",
            data: { cart_id: cartId },
        })
        .then(res => res.data)
        .catch(e => ExceptionHandling.HandleErrors(e));
    }

    loadForEdit(cartId) {
        return instance()({
            method: "get",
            url: `/api/load_for_edit/${cartId}`,
        })
        .then(res => res.data)
        .catch(e => ExceptionHandling.HandleErrors(e));
    }

    reissueToken(cartId, items, customerData, cartData) {
        return instance()({
            method: "post",
            url: "/api/reissue_token",
            data: {
                cart_id:          cartId,
                items:            items,
                customer_id:      customerData.customerID,
                customer_name:    customerData.customerName,
                customer_tel:     customerData.customerTel,
                invoice_discount: cartData.invoiceDiscount,
                disc_type:        cartData.discType,
                description:      cartData.description,
                doctor_details:   cartData.doctorDetails,
                patient_details:  cartData.patientDetails,
            },
        })
        .then(res => res.data)
        .catch(e => ExceptionHandling.HandleErrors(e));
    }

    upsertDraftCart(cartId, items, customerData, cartData) {
        return instance()({
            method: "post",
            url: "/api/upsert_draft",
            data: {
                cart_id:          cartId,
                items:            items,
                customer_id:      customerData.customerID,
                customer_name:    customerData.customerName,
                customer_tel:     customerData.customerTel,
                invoice_discount: cartData.invoiceDiscount,
                disc_type:        cartData.discType,
                description:      cartData.description,
                doctor_details:   cartData.doctorDetails,
                patient_details:  cartData.patientDetails,
            },
        })
        .then(res => res.data)
        .catch(e => ExceptionHandling.HandleErrors(e));
    }

    tokeniseDraft(cartId) {
        return instance()({
            method: "post",
            url: "/api/tokenise_draft",
            data: { cart_id: cartId },
        })
        .then(res => res.data)
        .catch(e => ExceptionHandling.HandleErrors(e));
    }

    discardDraft(cartId) {
        return instance()({
            method: "post",
            url: "/api/discard_draft",
            data: { cart_id: cartId },
        })
        .then(res => res.data)
        .catch(e => ExceptionHandling.HandleErrors(e));
    }

    completeDraft(cartId, receiptNo = null) {
        return instance()({
            method: "post",
            url: "/api/complete_draft",
            data: { cart_id: cartId, receipt_no: receiptNo },
        })
        .then(res => res.data)
        .catch(e => ExceptionHandling.HandleErrors(e));
    }

    syncEditCart(cartId, items, customerData, cartData) {
        return instance()({
            method: "post",
            url: "/api/sync_edit_cart",
            data: {
                cart_id:          cartId,
                items:            items,
                customer_id:      customerData.customerID,
                customer_name:    customerData.customerName,
                customer_tel:     customerData.customerTel,
                invoice_discount: cartData.invoiceDiscount,
                disc_type:        cartData.discType,
                description:      cartData.description,
                doctor_details:   cartData.doctorDetails,
                patient_details:  cartData.patientDetails,
            },
        })
        .then(res => res.data)
        .catch(e => ExceptionHandling.HandleErrors(e));
    }

}